import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var FABRIC_CHANNEL = 'fabric-elements';
export var createStatusAnalyticsAndFire = function createStatusAnalyticsAndFire(createAnalyticsEvent) {
  return function (payload) {
    if (createAnalyticsEvent && payload) {
      var statusPayload = _objectSpread(_objectSpread({}, payload), {}, {
        eventType: 'ui'
      });
      if (!statusPayload.attributes) {
        statusPayload.attributes = {};
      }
      statusPayload.attributes.componentName = 'status';
      createAnalyticsEvent(statusPayload).fire(FABRIC_CHANNEL);
    }
  };
};
export var analyticsState = function analyticsState(isNew) {
  return isNew ? 'new' : 'update';
};